import { cn } from '../../lib/utils';
import { alertVariants } from './variants';
import { Button } from '../Button/Button';
import { IconX } from '@tabler/icons-react';
import type {
  AlertProps,
  AlertWrapperProps,
  AlertTitleProps,
  AlertDescriptionProps,
} from './types';

function AlertWrapper({ className, variant, ...props }: AlertWrapperProps) {
  return (
    <div
      data-slot='alert'
      role='alert'
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: AlertTitleProps) {
  return (
    <div
      data-slot='alert-title'
      className={cn(
        'eye:headline-s',
        'eye:tracking-tight eye:col-start-2',
        className,
      )}
      {...props}
    />
  );
}

function AlertDescription({ className, ...props }: AlertDescriptionProps) {
  return (
    <div
      data-slot='alert-description'
      className={cn(
        'eye:body-m',
        'eye:col-start-2 eye:grid eye:justify-items-start eye:gap-1',
        className,
      )}
      {...props}
    />
  );
}

function Alert({ title, onClose, children, ...props }: AlertProps) {
  return (
    <AlertWrapper {...props}>
      {onClose && (
        <Button
          size='icon'
          variant='ghost'
          onClick={onClose}
          className='eye:absolute eye:right-[0] eye:m-4xs'
        >
          <IconX />
        </Button>
      )}
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription>{children}</AlertDescription>
    </AlertWrapper>
  );
}

export { Alert, AlertWrapper, AlertTitle, AlertDescription };
